var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "receviceRuleFormRef",
          staticClass: "demo-receviceRuleForm",
          attrs: { model: _vm.receviceRuleForm, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _vm.changeType === 2
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("placeOrder.name"),
                            prop: "receiveName",
                            rules: _vm.receiveNameRules,
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("placeOrder.pleaseInput"),
                              clearable: "",
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.receviceRuleForm.receiveName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.receviceRuleForm,
                                  "receiveName",
                                  $$v
                                )
                              },
                              expression: "receviceRuleForm.receiveName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.changeType === 2
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.MobilePhone"),
                            rules: _vm.isPhone,
                            prop: "receiveMobile",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("placeOrder.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.receviceRuleForm.receiveMobile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.receviceRuleForm,
                                  "receiveMobile",
                                  $$v
                                )
                              },
                              expression: "receviceRuleForm.receiveMobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.changeType === 2
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("placeOrder.TaxCPF"),
                            rules: _vm.isTax12,
                            prop: "receiveTax",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "newOrder.PleaseEnter12Or14DigitTaxNumber"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.receviceRuleForm.receiveTax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.receviceRuleForm,
                                  "receiveTax",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "receviceRuleForm.receiveTax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.zipcode"),
                        rules: _vm.isZipCode,
                        prop: "receiveZipcode",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("placeOrder.pleaseInput"),
                          clearable: "",
                        },
                        on: { change: _vm.changeZipCode },
                        model: {
                          value: _vm.receviceRuleForm.receiveZipcode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.receviceRuleForm,
                              "receiveZipcode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "receviceRuleForm.receiveZipcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.State"),
                        rules: {
                          required: true,
                          message: _vm.$t("placeOrder.pleaseInput"),
                          trigger: ["blur", "change"],
                        },
                        prop: "receiveState",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseInput"),
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.stateChangeOption },
                          model: {
                            value: _vm.receviceRuleForm.receiveState,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.receviceRuleForm,
                                "receiveState",
                                $$v
                              )
                            },
                            expression: "receviceRuleForm.receiveState",
                          },
                        },
                        _vm._l(_vm.senderStateList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.shortName,
                              value: item.shortName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.city"),
                        prop: "receiveCity",
                        rules: _vm.cityComplement,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "formTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            "remote-method": _vm.getSenderCity,
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            "visible-change": function ($event) {
                              return _vm.getSenderCity()
                            },
                          },
                          model: {
                            value: _vm.receviceRuleForm.receiveCity,
                            callback: function ($$v) {
                              _vm.$set(_vm.receviceRuleForm, "receiveCity", $$v)
                            },
                            expression: "receviceRuleForm.receiveCity",
                          },
                        },
                        _vm._l(_vm.cityList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.Area"),
                        rules: _vm.addressComplement,
                        prop: "receiveArea",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("placeOrder.pleaseInput"),
                          clearable: "",
                          maxlength: "32",
                        },
                        model: {
                          value: _vm.receviceRuleForm.receiveArea,
                          callback: function ($$v) {
                            _vm.$set(_vm.receviceRuleForm, "receiveArea", $$v)
                          },
                          expression: "receviceRuleForm.receiveArea",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("newOrder.Street"),
                        prop: "receiveStreet",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("newOrder.ConfirmStreetNumber"),
                          clearable: "",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.receviceRuleForm.receiveStreet,
                          callback: function ($$v) {
                            _vm.$set(_vm.receviceRuleForm, "receiveStreet", $$v)
                          },
                          expression: "receviceRuleForm.receiveStreet",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.HouseNumber"),
                        rules: _vm.checkStr5,
                        prop: "receiveHouseNumber",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("placeOrder.pleaseInput"),
                          clearable: "",
                          maxlength: "6",
                        },
                        model: {
                          value: _vm.receviceRuleForm.receiveHouseNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.receviceRuleForm,
                              "receiveHouseNumber",
                              $$v
                            )
                          },
                          expression: "receviceRuleForm.receiveHouseNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.addressComplement"),
                        rules: _vm.addressComplement,
                        prop: "receiveComplement",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("placeOrder.pleaseInput"),
                          clearable: "",
                          maxlength: "32",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.receviceRuleForm.receiveComplement,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.receviceRuleForm,
                              "receiveComplement",
                              $$v
                            )
                          },
                          expression: "receviceRuleForm.receiveComplement",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        label: _vm.$t("placeOrder.detailedAddress"),
                        rules: _vm.isReceiveAddress,
                        prop: "receiveAddress",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("placeOrder.pleaseInput"),
                          clearable: "",
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.receviceRuleForm.receiveAddress,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.receviceRuleForm,
                              "receiveAddress",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "receviceRuleForm.receiveAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }